<template>
  <el-dialog
    v-model="dialogFormVisible"
    title="绑定会员"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="绑定会员" prop="profile">
        <el-autocomplete
          v-model="profile"
          :fetch-suggestions="querySearchAsync"
          placeholder="查询会员手机号"
          @select="handleSelect"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { bindProfile, getProfiles } from '@/api/people'

  export default {
    name: 'PeoplePeopleEdit',
    emits: ['fetch-data'],
    data() {
      return {
        profile: '',
        form: {
          profileId: '',
        },
        rules: {
          profileId: [
            { required: true, trigger: 'blur', message: '请输入会员手机号' },
          ],
        },
        dialogFormVisible: false,
      }
    },
    methods: {
      async querySearchAsync(queryString, cb) {
        if (!queryString) return
        const ret = await getProfiles({
          tel: queryString,
          page: 1,
          size: 10,
        })
        cb(
          ret.list.map((e) => ({
            value: `${e.name}（${e.tel}）`,
            profileId: e.profileId,
          }))
        )
      },
      handleSelect(item) {
        this.form.profileId = item.profileId
      },
      showEdit(row) {
        this.form = Object.assign(
          {},
          {
            peopleId: row.peopleId,
            profileId: row.basic.profileId,
          }
        )
        this.dialogFormVisible = true
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await bindProfile(this.form)
            this.$baseMessage(
              '绑定会员成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
